// extracted by mini-css-extract-plugin
export default {"breadcrumb":"style_breadcrumb__b6ESW"};